import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'nprogress/nprogress.css';
import 'src/assets/css/prism.css';
import 'src/mixins/chartjs';
import 'src/mixins/prismjs';
import { enableES5 } from 'immer';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {
  i18nSetup,
  restoreSettings,
  SettingsProvider
} from '@nsd/fe';
import { store } from 'src/store';
import App from 'src/App';
import enDashboardStrings from 'src/constants/strings/en/dashboard';
import frDashboardStrings from 'src/constants/strings/fr/dashboard';
import esDashboardStrings from 'src/constants/strings/es/dashboard';
import esAppStrings from 'src/constants/strings/es/app';
import enAppStrings from 'src/constants/strings/en/app';
import frAppStrings from 'src/constants/strings/fr/app';
import esDispatchBoardStrings from 'src/constants/strings/es/dispatchBoard';
import enDispatchBoardStrings from 'src/constants/strings/en/dispatchBoard';
import frDispatchBoardStrings from 'src/constants/strings/fr/dispatchBoard';
import enCreateDispatchStrings from 'src/constants/strings/en/createDispatch';
import frCreateDispatchStrings from 'src/constants/strings/fr/createDispatch';
import esCreateDispatchStrings from 'src/constants/strings/es/createDispatch';

import frAddressTypes from 'src/constants/strings/fr/addressTypes';
import esAddressTypes from 'src/constants/strings/es/addressTypes';
import enAddressTypes from 'src/constants/strings/en/addressTypes';
import frPhoneTypes from 'src/constants/strings/fr/phoneTypes';
import esPhoneTypes from 'src/constants/strings/es/phoneTypes';
import enPhoneTypes from 'src/constants/strings/en/phoneTypes';
import enTopBar from 'src/constants/strings/en/TopBar';
import esTopBar from 'src/constants/strings/es/TopBar';
import frTopBar from 'src/constants/strings/fr/TopBar';
import Cookies from 'js-cookie';
import enCancelDispatchForm from './constants/strings/en/cancelDispatchForm';
import esCancelDispatchForm from './constants/strings/es/cancelDispatchForm';
import frCancelDispatchForm from './constants/strings/fr/cancelDispatchForm';
import enProviderAssignment from './constants/strings/en/providerAssignment';
import esProviderAssignment from './constants/strings/es/providerAssignment';
import frProviderAssignment from './constants/strings/fr/providerAssignment';

// Same name from App.js; for making an educated
// guess on the alert and notification path
// (also can pass in manual path in App.js)
const APP_INTERNAL_NAME = 'provider-qore';

enableES5();

const settings = restoreSettings();
i18nSetup({
  en: {
    translation: {
      app: enAppStrings,
      phoneTypes: enPhoneTypes,
      addressTypes: enAddressTypes,
      dispatching: {
        dispatchBoardStrings: enDispatchBoardStrings,
        createDispatch: enCreateDispatchStrings,
        cancelDispatchForm: enCancelDispatchForm
      },
      reports: {
        dashboardView: enDashboardStrings
      },
      topBar: enTopBar,
      providerAssignment: enProviderAssignment
    }
  },
  fr: {
    translation: {
      app: frAppStrings,
      phoneTypes: frPhoneTypes,
      addressTypes: frAddressTypes,
      dispatching: {
        dispatchBoardStrings: frDispatchBoardStrings,
        createDispatch: frCreateDispatchStrings,
        cancelDispatchForm: frCancelDispatchForm
      },
      reports: {
        dashboardView: frDashboardStrings
      },
      topBar: frTopBar,
      providerAssignment: frProviderAssignment
    }
  },
  es: {
    translation: {
      app: esAppStrings,
      phoneTypes: esPhoneTypes,
      addressTypes: esAddressTypes,
      dispatching: {
        dispatchBoardStrings: esDispatchBoardStrings,
        createDispatch: esCreateDispatchStrings,
        cancelDispatchForm: esCancelDispatchForm
      },
      reports: {
        dashboardView: esDashboardStrings
      },
      topBar: esTopBar,
      providerAssignment: esProviderAssignment
    }
  }
}, false);

Cookies.set('consent', 'true');

ReactDOM.render(
  <Provider store={store}>
    <SettingsProvider settings={settings}>
      <App />
    </SettingsProvider>
  </Provider>,
  document.getElementById('root')
);
